module.exports = __webpack_public_path__ + "static/media/campus_5.1672cbfd.png";